var React = require('react');

function Pinterest (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.00001 14.5C5.00001 10 9.46201 6.5 12.5 6.5C15.538 6.5 18 8.154 18 12C18 15.038 16 17 14 17C12 17 11 15 11.5 12M12 10L9.00001 21.5","stroke":"#1E2226","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z","stroke":"#1E2226","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Pinterest.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Pinterest;

Pinterest.default = Pinterest;
